"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vanilla_lazyload_1 = __importDefault(require("vanilla-lazyload"));
var LazyLoader = /** @class */ (function () {
    function LazyLoader() {
        this.config = {
            lazyLoad: null,
            classNames: {
                lazy: 'lazy'
            },
            selectors: {
                element: '.lazy'
            }
        };
    }
    LazyLoader.prototype.init = function () {
        this.config.lazyLoad = new vanilla_lazyload_1.default({
            elements_selector: this.config.selectors.element,
            container: document.querySelector('body')
        });
    };
    LazyLoader.prototype.update = function () {
        this.config.lazyLoad.update();
    };
    LazyLoader.prototype.add = function (nodeList) {
        nodeList.forEach(function (node) { return node.classList.add('lazy'); });
    };
    return LazyLoader;
}());
exports.default = new LazyLoader();
